import React, { useState, useEffect } from 'react';
import { Radio, Table, Button, InputNumber } from 'antd';
import { cloneDeep, set } from 'lodash';

type Iprops = {
  value: any;
  onChange: any;
}

const DiscountPlan:React.FC<Iprops> = (props) => {
  const { value } = props;

  const columns: any = [
    {
      title: '档位',
      dataIndex: 'gear_position',
      key: 'gear_position',
      render: (text: any, record: any, index: number) => {
        return (
          <>
            档位{index + 1}：租期{record.gear_position}天以上（包含）
          </>
        )
      }
    },
    {
      title: '优惠力度',
      dataIndex: 'discount_level',
      key: 'discount_level',
      render: (text: any, record: any, index: number) => {
        return (
          <>
            每单优惠{record.discount_level}%
          </>
        )
      }
    }
  ];

  return (
    <>
      <div style={{ lineHeight: '32px' }}>订单租期满足以下门槛时，可享受不同优惠力度（限租车费）</div>
      <Table columns={columns} dataSource={value?.combination || [{}]} pagination={false} />
    </>
  )
}

export default DiscountPlan;